import { Swiper, SwiperSlide } from 'swiper/react';
import * as React from 'react';
import { css } from '@emotion/css/macro';

const style = css`
  width: 100%;
`;
const slideView = css`
  left: 0;
  margin: 24px auto;
  width: 244px;
  text-align: center;
  img {
    width: 244px;
  }
  h5 {
    font-size: 16px;
    line-height: 1.75px;
    letter-spacing: -0.6px;
    color: #4a4a4a;
    font-weight: bold;
    margin: 22px 0;
  }
  p {
    font-size: 16px;
    letter-spacing: -0.6px;
    color: #757575;
  }
`;

export default function SwiperView({ setView }) {
  const [swiper, setSwiper] = React.useState(null);
  return (
    <Swiper
      noSwiping={false}
      className={style}
      slidesPerView={1}
      onSlideChange={() => {
        setView(swiper.activeIndex + 1);
      }}
      onSwiper={(swiper) => {
        setSwiper(swiper);
      }}
      centeredSlides={true}
    >
      <SwiperSlide style={{ width: '244px' }}>
        <article className={slideView}>
          <img src='//static.dogmate.co.kr/dogit/landing-v3/dogit-v3-step1.gif' />
          <h5>
            <u>STEP1. 알림이 오면 미션을 시작해요</u>
          </h5>
          <p>내가 정해놓은 시간에 미션이 도착해요</p>
        </article>
      </SwiperSlide>
      <SwiperSlide style={{ width: '244px' }}>
        <article className={slideView}>
          <img src='//static.dogmate.co.kr/dogit/landing-v3/dogit-v3-step2.gif' />
          <h5>
            <u>STEP2. 스텝별로 미션을 따라해요</u>
          </h5>
          <p>
            순서대로 차근 차근 알려주니
            <br /> 훈련이 쉬워져요
          </p>
        </article>
      </SwiperSlide>
      <SwiperSlide style={{ width: '244px' }}>
        <article className={slideView}>
          <img src='//static.dogmate.co.kr/dogit/landing-v3/dogit-v3-step3.gif' />
          <h5>
            <u>STEP3. 내 강아지의 반응을 선택해요</u>
          </h5>
          <p>
            강아지가 보인 반응에 따라
            <br />
            나만의 맞춤 커리큘럼이 만들어져요
          </p>
        </article>
      </SwiperSlide>
      <SwiperSlide style={{ width: '244px' }}>
        <article className={slideView}>
          <img src='//static.dogmate.co.kr/dogit/landing-v3/dogit-v3-step4.gif' />
          <h5>
            <u>STEP4. 잘 안되는 건 바로 상담해요</u>
          </h5>
          <p>
            나만의 전문 매니저와
            <br />
            실시간으로 대화를 나눌 수 있어요
          </p>
        </article>
      </SwiperSlide>
    </Swiper>
  );
}
